import { AssetOrder } from './asset-order';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { AssetProduct } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-entity';



export class AssetOrderLine extends BaseEntity {

  assetOrder        : AssetOrder = new AssetOrder();
  assetProduct      : AssetProduct = new AssetProduct();
  quantity          : number;
  deliveredQuantity : number;
  

  // for Asset reception use 
  //----------------------------------------
  expectedQuantity      : number;
  serialNumber          : string;
  serialNumbers         : string[] = [];
  serialNumbersToDelete : string[] = [];
  shrinkMode            : boolean = true;
//----------------------------------------
 
  constructor() {
    super();

  }
}